var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.703,
    height: 20.703,
    viewBox: "0 0 20.703 20.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4A87F8;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7137 763)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7137 -763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.7,26.352A10.352,10.352,0,1,1,26.352,16,10.352,10.352,0,0,1,36.7,26.352ZM24.025,24.235a.45.45,0,0,1,.21-.21l7.316-3.048c.165-.069.243.01.175.175l-3.048,7.316a.45.45,0,0,1-.21.21l-7.316,3.048c-.165.069-.243-.01-.175-.175Z",
    transform: "translate(-16 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.617,46.235A1.617,1.617,0,1,0,43,44.617,1.617,1.617,0,0,0,44.617,46.235Z",
    transform: "translate(-34.266 -34.266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsActive);
export default __webpack_public_path__ + "static/media/products_active.7c8d5f580509de4f726fc74ce5491ed6.svg";
export { ForwardRef as ReactComponent };